let installed = false;

function isHashOnlyNavigation(to, from) {
    return (
        to.path === from.path &&
        JSON.stringify(to.query) === JSON.stringify(from.query)
    );
}

export function useCoverRouting() {
    if (!import.meta.client || installed) return;
    installed = true;

    const router = useRouter();
    const nuxtApp = useNuxtApp();
    const globalStore = useGlobalStore();
    const { cover, emergencyUncover, isCovered } = useCoverNavigation();

    router.beforeEach(async (to, from) => {
        if (!from.matched.length) return;
        if (!globalStore.appLoadingComplete) return;
        if (to.meta?.noCover) return;
        if (isHashOnlyNavigation(to, from)) return;

        await cover();
    });

    router.afterEach((_to, _from, failure) => {
        if (failure && isCovered.value) {
            emergencyUncover();
        }
    });

    nuxtApp.hook('app:error', () => {
        if (isCovered.value) emergencyUncover();
    });
}
